import { selector } from "recoil"

import { safeSavingsState } from "../designs/design-state"

export const averageMonthEachYearWithoutSolarState = selector<
  {
    cost: number
    rate: number
    date: Date
  }[]
>({
  key: `averageMonthEachYearWithoutSolar`,
  get: ({ get }) => {
    const savings = get(safeSavingsState)
    const yearsInSeries = savings?.outputs?.seriesData?.filter(
      (y) => y.seriesId === 5,
    )

    const annualBeforeSolarUtility = yearsInSeries ?? []

    const costsByDate = annualBeforeSolarUtility.map((y) => ({
      cost: (y.cost ?? 0) / 12,
      rate: y.rate ?? 0,
      date: new Date(y?.fromDateTime ?? 0),
    }))

    return costsByDate
  },
})
